import React, { useEffect, useState } from "react";
import api from "~/services/api";
import CreateEditContent from "./CreateEditContent";
import { LandPage, Container, Main } from './styles';
import CustomBodyContent from "./CustomBodyContent";
import { Colors } from "~/config/Colors";
import {
  SLEditModal,
  SLCreateModal,
} from "~/pages/Sistema/componentes/SistemaList";
import { useSelector } from "react-redux";

export default function ConfigJobEmail() {
  const [data, setData] = useState([]);
  const [modulos, setModulos] = useState([]);
  const [unidades, setUnidades] = useState([]);
  const [mountedData, setMountedData] = useState();
  const [loadedData, setLoadedData] = useState(false);
  const { perfil, idUnidades, controle } = useSelector(state => state.auth);

  useEffect(() => {
    setLoadedData(false);
  }, [perfil]);

  useEffect(() => {
    async function handleRequests() {
      api
        .get('/signed/geral/acessos/check')
        .then(response => setModulos(response.data));
    }

    handleRequests();
    
    api.get('/signed/cliente/administracao/organizacao/unidades', { params: { centroCusto: "S" } }).then(response => {
      let lista = [];
      for (const item of idUnidades) {
        const itemFind = response?.data?.find((o) => o?.id == item);
        
        if (itemFind) {
          let listaCC = [];
          for (const itemCC of itemFind?.centroCustos) {
            listaCC.push({ id: itemCC?.id, titulo: itemCC?.titulo });
          }

          lista.push({ id: itemFind?.id, titulo: itemFind?.nome, centroCustos: listaCC });
        }
      }
      setUnidades(lista);
    });
  }, []);

  return (
    <Main>
      <LandPage>
        <div className="content">
          <Container
            requests={{
              findAll: () =>
                api.get('/signed/cliente/pesquisa/email/configjobemails'),
              findOne: thisData =>
                api.get('/signed/cliente/pesquisa/email/configjobemail', {
                  params: { id: thisData.id },
                }),
              deleteOne: thisData =>
                api.delete('/signed/cliente/pesquisa/email/configjobemail', {
                  data: { id: thisData.id },
                }),
            }}
            setter={setData}
            setLoaded={setLoadedData}
            loaded={loadedData}
            informationPage={{
              title: 'Configuração do JOB de Email',
              subTitle: "Crie configurações de envio de email que será executado em um JOB",
              icone: 'submenu-pesquisa',
            }}
            pageSize={8}
            inputs={[
              { filter: 'titulo', label: 'Titulo' },
              { filter: 'id', label: 'Id' },
            ]}
            selects={[
              {
                list: unidades,
                value: "id",
                label: "titulo",
                outLabel: "Todas Unidades",
                filter: "idUnidade",
              },
            ]}
          >
            <SLEditModal title="Atualizar Configuração" setter={setMountedData}>
              {mountedData && modulos && (
                <CreateEditContent {...{ modulos, mountedData, unidades }} />
              )}
            </SLEditModal>

            <SLCreateModal title="Adicionar Configuração">
              {modulos && <CreateEditContent {...{ modulos, unidades }} />}
            </SLCreateModal>

            <CustomBodyContent {...{ data }} />
          </Container>
        </div>
      </LandPage>
    </Main>
  );
}
